import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-inseason-confirm-order-thank-you-page',
    templateUrl: './inseason-confirm-order-thank-you-page.component.html',
    styleUrl: './inseason-confirm-order-thank-you-page.component.scss',
    standalone: false
})
export class InseasonConfirmOrderThankYouPageComponent {
  enablePage: any;
  seasonValue: any;
  thankYouContent: Observable<any> = this.PageParagraphComponent.data$;
  inseasonContent: any;
  constructor(private userInfoService: UserInfoService, private cdr: ChangeDetectorRef,private router: Router,private cmsService: CmsService,public PageParagraphComponent : CmsComponentData<any>,private contentservice:ContentService) { }
  ngOnInit() {
    this.userInfoService.getstartorderseason().subscribe((seasonValue: any) => {
      this.seasonValue = seasonValue;
      this.userInfoService.getEnablePage().subscribe((data: any) => {
        this.enablePage = data;
        this.cdr.detectChanges();
      })
      
    })
    this.thankYouContent.subscribe((res: any) => {
      this.inseasonContent=res;
    });
  }
  handleOnOrdersClick() {
    this.router.navigate(
      ['/orders/my-orders'],
      { queryParams: { season: this.seasonValue} }
   );
  }
}
